<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-header>
                <span class="h5">SOLICITAÇÕES DE ADITIVOS</span>
                <div class="float-right">
                    <span class="text-primary">
                        <i
                            class="fa fa-refresh fa-lg icon-button"
                            title="Atualizar"
                            @click.stop="$emit('atualizar-listagem')"
                        ></i>
                    </span>
                </div>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <app-tabela
                    :itens="solicitacoesAditivos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-row>
                            <b-col sm="12">
                                <b-form inline class="justify-content-end">
                                    <label class="mr-sm-2">Status</label>
                                    <b-form-select
                                        class="mb-2 mr-sm-2 mb-sm-0"
                                        :plain="true"
                                        :options="statusLista"
                                        v-model="statusSelecionado"
                                    ></b-form-select>
                                </b-form>
                            </b-col>
                        </b-row>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <div class="justify-content">
                            <btn-processar
                                v-if="
                                    $temAcessoView('CRED-UABS-ADIT-01') &&
                                        data.status == 0
                                "
                                :solicitacaoAditivo="data"
                                :solicitacoesAditivosServicos="
                                    solicitacoesAditivosServicos
                                "
                                @atualizar-listagem="
                                    $emit('atualizar-listagem')
                                "
                            ></btn-processar>
                            <btn-reprovar
                                class="ml-1"
                                v-if="
                                    $temAcessoView('CRED-UABS-ADIT-01') &&
                                        data.status == 0
                                "
                                :solicitacaoAditivo="data"
                                :solicitacoesAditivosServicos="
                                    solicitacoesAditivosServicos
                                "
                                @atualizar-listagem="
                                    $emit('atualizar-listagem')
                                "
                            ></btn-reprovar>
                            <btn-detalhe-reprovacao
                                class="ml-1"
                                v-if="data.status == 2"
                                :solicitacaoAditivo="data"
                            ></btn-detalhe-reprovacao>
                        </div>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import BtnProcessar from './BtnProcessar'
import BtnReprovar from './BtnReprovar'
import BtnDetalheReprovacao from './BtnDetalheReprovacao'

export default {
    components: {
        BtnProcessar,
        BtnReprovar,
        BtnDetalheReprovacao
    },

    props: {
        solicitacoesAditivos: {
            type: Array,
            default: () => []
        },

        solicitacoesAditivosServicos: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            erros: [],
            // solicitacoesAditivosFiltradas: [],
            statusSelecionado: 0,
            statusLista: [
                { value: -1, text: 'TODAS' },
                { value: 0, text: 'EM PROCESSAMENTO' },
                { value: 1, text: 'PROCESSADA' },
                { value: 2, text: 'REPROVADA' }
            ],
            campos: [
                {
                    key: 'dataCadastro',
                    label: 'Data da Solicitação',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'usuarioSolicitante',
                    label: 'Solicitado por',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'codContratacao',
                    label: 'Contratação',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'novaDataFim',
                    label: 'Nova data de conclusão',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'qtdHorasAdicionais',
                    label: 'Qtd Horas Adicionais',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'justificativa',
                    label: 'Justificativa',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'observacoes',
                    label: 'Observações',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'usuarioProcessamento',
                    label: 'Processada por',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {},

    created() {},

    computed: {
        mostrarTabela() {
            return true
        }
    },

    watch: {
        statusSelecionado(newValue) {
            this.$emit('atualizar-status-selecionado', newValue)
        }
    }
}
</script>
